import { useState } from 'react';

interface AIPrefillBannerProps {
  explanation?: string;
  onDismiss: () => void;
}

/**
 * Dismissible banner shown when a form has been pre-filled by the AI copilot.
 * Displays in Lithuanian: "AI uzpilde sia forma. Perziurekite duomenis ir patvirtinkite."
 */
export default function AIPrefillBanner({ explanation, onDismiss }: AIPrefillBannerProps) {
  const [visible, setVisible] = useState(true);

  if (!visible) return null;

  const handleDismiss = () => {
    setVisible(false);
    onDismiss();
  };

  return (
    <div className="bg-amber-50 border border-amber-200 rounded-lg p-3 flex items-start gap-3">
      <svg className="w-5 h-5 text-amber-500 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
      </svg>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-medium text-amber-800">
          AI uzpilde sia forma. Perziurekite duomenis ir patvirtinkite.
        </p>
        {explanation && (
          <p className="text-sm text-amber-600 mt-1">{explanation}</p>
        )}
      </div>
      <button
        onClick={handleDismiss}
        className="flex-shrink-0 p-1 rounded hover:bg-amber-100 text-amber-400 hover:text-amber-600 transition-colors"
        title="Uzdaryti"
      >
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
  );
}
